import { SidePanelShell } from "@/components/ui/SidePanelShell";
import { NeedsAttentionRow } from "@/lib/api/risk/brokerage/tt/v2";
import { OrderDetailContent } from "./OrderDetailContent";

interface OrderSidePanelProps {
  guidOrderId: string | null;
  wasResolved: boolean;
  onClose: () => void;
  /** When false, hide the AttachOrderForm section entirely (read-only panel). Default true. */
  showAttachForm?: boolean;
  /**
   * When true, render a read-only summary of the AssociatedMetaData (expected
   * types, OTC contract, crop year, should_ignore, customer splits) between
   * the Order Context and Order Events sections. Default false.
   *
   * Used by Active Orders where the form is hidden but the user still wants
   * to see what was previously associated.
   */
  showAssociatedMetadata?: boolean;
  /** Already-fetched orders offered as link targets by the attach form. */
  orders?: NeedsAttentionRow[];
}

export function OrderSidePanel({
  guidOrderId,
  wasResolved,
  onClose,
  showAttachForm = true,
  showAssociatedMetadata = false,
  orders,
}: OrderSidePanelProps) {
  return (
    <SidePanelShell title="Order Details" onClose={onClose}>
      <OrderDetailContent
        guidOrderId={guidOrderId}
        wasResolved={wasResolved}
        showAttachForm={showAttachForm}
        showAssociatedMetadata={showAssociatedMetadata}
        orders={orders}
      />
    </SidePanelShell>
  );
}
